import { AbstractControl, ValidationErrors } from '@angular/forms';

import { OnBehalfFormArrayModel } from '../model/room-booking-form.model';

export function uniqueOnBehalfValidator() {
  return (formArray: OnBehalfFormArrayModel): ValidationErrors | null => {
    const emails = formArray.controls
      .map(control => control.value)
      .filter((email): email is string => !!email)
      .map(email => email.toLowerCase());

    return new Set(emails).size === emails.length
      ? null
      : { duplicateOnBehalf: true };
  };
}

/**
 * A booking cannot be made on behalf of the person who requests it. The
 * requester is read lazily, because it is only known once the edited booking
 * is loaded.
 */
export function onBehalfNotRequesterValidator(
  requesterEmail: () => string | null
) {
  return (control: AbstractControl): ValidationErrors | null => {
    const email = control.value as string | null;
    const requester = requesterEmail();

    if (!email || !requester) {
      return null;
    }

    return email.toLowerCase() === requester.toLowerCase()
      ? { onBehalfIsRequester: true }
      : null;
  };
}
